exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Header__header___3tIOR {\n  display: flex;\n  justify-content: space-between;\n  height: 90px;\n  flex-shrink: 0; }\n  .Header__header___3tIOR div:nth-child(1) {\n    height: 90px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 20px; }\n", ""]);

// exports
exports.locals = {
	"header": "Header__header___3tIOR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Header/Header/Header.scss
// module id = 713
// module chunks = 0